export const currencyTypes = {
    1: '钻石',
    3: '游戏币',
    4: '金币'
  }